import {addQueryToPath} from '../../../libs/shared/helpers/src/browser/urlHelpers';

/*
 * Search URL.
 */

export enum InboxSearchSortOrdersEnum {
  NAME_ASC = 'name',
  NAME_DESC = '-name',
  PUBLIC_ASC = 'public',
  PUBLIC_DESC = '-public',
}

export interface SearchInboxOptions {
  /** Only list inboxes after the offset. */
  offset?: number;
  /** Limits the number of inboxes returned in the response. */
  limit?: number;
  /** Whether to include private inboxes. */
  shouldIncludePrivate?: boolean;
  /** Search inboxes in a specific namespace */
  namespace?: string;
  /** Returns channels alongside inboxes. */
  shouldIncludeChannels?: boolean;
  /** Sort inboxes by field */
  sortOrder?: InboxSearchSortOrdersEnum;
}

export function buildInboxSearchUrl(companyUrl: string, query: string, options: SearchInboxOptions) {
  if (options.namespace) {
    return addQueryToPath(
      `${companyUrl}/namespaces/${options.namespace}/search_inbox/${encodeURIComponent(query.toLowerCase())}`,
      serializeSearchInboxOptions(options),
    );
  }

  return addQueryToPath(
    `${companyUrl}/search_inbox/${encodeURIComponent(query.toLowerCase())}`,
    serializeSearchInboxOptions(options),
  );
}

function serializeSearchInboxOptions(options: SearchInboxOptions) {
  return {
    offset: options.offset || 0,
    limit: options.limit || 50,
    include_private: options.shouldIncludePrivate || false,
    with_channels: options.shouldIncludeChannels || false,
    sort: options.sortOrder,
  };
}
